import { Row } from '@tanstack/react-table';
import { Avatar } from '../../../../design-system/avatar/avatar/avatar';
import { FaIcon } from '../../../../design-system/icon/fa-icon';
import { Inline } from '../../../../design-system/inline/inline';
import { ReportingData } from '../../utils/get-reporting-data';
import { ExpansionChevronIconButton } from './expansion-chevron-icon-button';

type ExpandableNameCellArgs = {
  row: Row<ReportingData>;
};

export const ExpandableNameCell = ({ row }: ExpandableNameCellArgs) => {
  const cellValue = row.getValue<string>('name');

  // If the row is not expandable, we have reached the lowest level: vendor level
  if (!row.getCanExpand()) {
    return (
      <Inline space={3} wrap="nowrap" className="min-w-0">
        <Avatar name={cellValue} avatarUrl={row.original.logo} size="2xs" />

        <p className="truncate text-nowrap">{cellValue}</p>
      </Inline>
    );
  }

  return (
    <Inline space={3} wrap="nowrap" className="min-w-0">
      <ExpansionChevronIconButton isExpanded={row.getIsExpanded()} onClick={row.getToggleExpandedHandler()} />

      <Inline space={1} wrap="nowrap" className="min-w-0">
        {row.original.icon && <FaIcon iconName={row.original.icon ?? ''} className="text-black" />}

        <p className="truncate text-nowrap">{cellValue}</p>
      </Inline>
    </Inline>
  );
};
